import { useEffect } from "react";
import { useFirstMountState } from "react-use";
import { Loading } from "@components/LoadMore/LoadMore";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { useGetReadingHistory } from "@pages/MyAccount/hooks/useGetReadingHistory";
import { GaObject } from "@pages/MyAccount/utils/types";

import MyAccountReadingHistoryEmptyState from "./MyAccountReadingHistoryEmptyState";
import MyAccountReadingHistoryList from "./MyAccountReadingHistoryList";

/**
 * MyAccountReadingHistoryPage is a component that conditionally renders an empty state or a list based on the number of reading history
 */
const MyAccountReadingHistoryPage = (): React.ReactElement => {
  const sendDataToGTM = useGTMDispatch();
  const isFirstMount = useFirstMountState();

  const {
    readArticleList,
    ref,
    handleDeleteReadingHistory,
    deleteArticleIdList,
    isLoading,
  } = useGetReadingHistory({
    pageSize: 10,
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isFirstMount) return;

    const gaObject: GaObject = {
      event: "custom_event",
      eventCategory: "recent read",
      eventAction: "visible",
      eventLabel: window.location.href,
    };

    sendDataToGTM(gaObject);
  }, [sendDataToGTM, isFirstMount]);

  return (
    <div data-testid="my-account-reading-history-page">
      {readArticleList.length > 0 ? (
        <MyAccountReadingHistoryList
          articleList={readArticleList}
          loadMoreRef={ref}
          handleDeleteArticle={handleDeleteReadingHistory}
          deleteArticleIdList={deleteArticleIdList}
        />
      ) : null}

      {readArticleList.length === 0 ||
      deleteArticleIdList.length === readArticleList.length ? (
        <MyAccountReadingHistoryEmptyState />
      ) : null}

      <Loading isLoading={isLoading} />
    </div>
  );
};

export default MyAccountReadingHistoryPage;
